import type { Language } from '@/shared/entities/Language'

export class CreateUpdateMealTierEntity {
  translations?: Array<{
    name: string
    language: Language
  }>
  icon?: { bytes: string; fileName: string }
}
